'use client'

// lib files
import { useHasMounted } from '@/lib/hooks';
import { usePersonalizedResource } from '@/lib/hooks/usePersonalizedResource';
import { myListVideos } from '@/lib/resources/my-list-videos';

// components
import LinkButton from '@/components/Button/LinkButton';
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner';
import MyListVideosGrid from '@/components/MyList/MyListVideos/MyListVideosGrid';
import SignInButton from '@/components/Navigation/SignInButton';

// styles
import styles from './MyListVideos.module.scss';

const MyListVideos = () => {
  const videos = usePersonalizedResource(myListVideos);
  const hasMounted = useHasMounted();

  if (!hasMounted) return null;

  let content = null;

  switch (videos.status) {
    case 'ready':
      content = <MyListVideosGrid videos={videos.items} />;
      break;
    case 'loading':
      content = <LoadingSpinner text="Loading Your List..." />;
      break;
    case 'idle':
    case 'empty':
    case 'error':
      content = (
        <div className={styles.my_list_videos_user_prompt}>
          <h2>Videos you add to My List will appear here.</h2>
          <LinkButton href="/shows/">
            Browse PBS Shows
          </LinkButton>
        </div>
      );
      break;
    case 'needsSignIn':
      content = (
        <div className={styles.my_list_videos_user_prompt}>
          <h2>Sign in to add videos to My List</h2>
          <SignInButton>
            Sign In to Access
          </SignInButton>
        </div>
      );
      break;
  }

  return (
    <div className={styles.my_list_videos}>
     {content}
    </div>
  );
};

export default MyListVideos;
